import { queryOptions } from '@tanstack/react-query';

import { parseSchema } from '@repo/utils/parse-schema';

import { cargoOverviewSchema, cargoSchema } from '~/services/cargo/types.ts';
import { http } from '~/services/http.ts';

const apiBase = `${import.meta.env.VITE_API_BASE}/cargo`;

export async function getCargoes(projectId: string) {
  return parseSchema(cargoOverviewSchema.array(), await http(`${apiBase}/projects/${projectId}/cargos`));
}

export function queryCargoes(projectId: string) {
  return queryOptions({
    queryFn: () => getCargoes(projectId),
    queryKey: [projectId, 'cargoes'],
  });
}

export async function getCargoById(projectId: string, id: string) {
  const cargo = parseSchema(cargoSchema, await http(`${apiBase}/projects/${projectId}/cargos/${id}`));
  cargo.batches.sort((a, b) => Date.parse(a.createdAt) - Date.parse(b.createdAt));

  return cargo;
}

export function queryCargoById(projectId: string, id: string) {
  return queryOptions({
    queryFn: () => getCargoById(projectId, id),
    queryKey: ['cargo', projectId, id],
  });
}
